<section>
  <div class="row">
    <div class="col field-report">
      <app-custom-select [labelText]="'Informe'" [list]="listReport" [required]="true" [recovery]="true"
        (onChangeSelect)="changeReport($event)"></app-custom-select>
    </div>
    <div class="col d-flex align-items-end gap-1">
      <app-custom-button *ngIf="showReport" [title]="'Exportar'" [severity]="'success'" [icon]="'pi pi-file-excel'"
        (onClick)="exportExcel()"></app-custom-button>
      <app-custom-button *ngIf="showReport" [title]="'Imprimir'" [severity]="'primary'" [icon]="'pi pi-print'"
        (onClick)="printReport()"></app-custom-button>
    </div>
  </div>
  <hr>
  <div class="report-content">
    <div class="alert alert-info" *ngIf="selectedReport === 0">Seleccione un informe para visualizar su contenido.</div>
    <div class="alert alert-secondary" *ngIf="selectedReport > 0 && !showReport">
      No hay datos para mostrar en este momento.
    </div>
    <div class="custom-table-container" *ngIf="showReport">
      <app-custom-table-report [dataReport]="dataReport" [footerTemplate]="reportSelected() ? tfootTpl : undefined">
      </app-custom-table-report>
    </div>
  </div>
</section>

<ng-template #tfootTpl>
  <tr>
    <td class="container-message" [attr.colspan]="50">
      <p id="message">Nota: La valoración de este informe es con un costo promedio calculado al
        inicial el inventario, puede variar al momento de aplicar método PEPS.</p>
    </td>
  </tr>
</ng-template>